<template>
  <div id="app">
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>

    <app-modals-container></app-modals-container>
  </div>
</template>

<script>
import AppHeader from './components/layout/AppHeader.vue';
import AppFooter from './components/layout/AppFooter.vue';

export default {
  name: 'app',

  components: {
    AppHeader,
    AppFooter
  },

  data() {
    return {};
  },

  methods: {}
};
</script>

<style>
* {
  box-sizing: border-box;
}

*:focus {
  outline: none;
}

html {
  min-height: 100%;
}

body {
  margin: 0;
  padding: 0;
  font-family: Tahoma, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  font-weight: normal;
  color: #061332;
  background-color: #f0f1f4;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}

.container {
  margin: 0 auto;
  padding: 0 10px;
  width: 100%;
  max-width: 1200px;
}

.button-primary {
  display: inline-block;
  border: none;
  border-radius: 3px;
  padding: 15px 10px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  background-color: #3c91e6;
  cursor: pointer;
}

.button-primary:hover {
  background-color: #29629c;
}

.button-primary:active {
  background-color: #2c316b;
}

.button-primary[disabled] {
  background-color: #3c91e6;
  opacity: .7;
  cursor: not-allowed;
}

.button-secondary {
  display: inline-block;
  border: 2px solid #3c91e6;
  border-radius: 3px;
  padding: 15px 10px;
  text-align: center;
  font-size: 16px;
  color: #061332;
  background-color: transparent;
  cursor: pointer;
  width: 100%;
}

.button-secondary:hover {
  color: #ffffff;
  background-color: #3c91e6;
}

.button-secondary:active {
  color: #ffffff;
  background-color: #29629c;
  border: 2px solid #29629c;
}

.hidden {
  display: none;
}

@media (max-width: 1023px) {
  .container {
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
  }
}

@media (max-width: 767px) {
  .container {
    padding: 0 10px;
  }
}

@media (max-width: 767px) {
  .hidden-sm {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .hidden-md {
    display: none !important;
  }
}
@media (min-width: 1024px) {
  .hidden-lg {
    display: none !important;
  }
}
</style>
